import Accordion from "react-bootstrap/Accordion";
import NavbarWithDrawer from "../../ComponentsWeb/Sub/NavbarWithDrawer";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getFrontEndQuickReply } from "../../reducers/commonReducer";
import { getAudioMimeType, isAudio, isImage, isVideo } from "../../const";

function QuickChat() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getFrontEndQuickReply());
  }, []);
  const { getFrontEndQuickReplyList } = useSelector(
    (state) => state.commonReducer
  );

  return (
    <>
      <NavbarWithDrawer />
      <div className="container-fluid bg-light min-vh-100 py-4 px-3 mt-5">
        <h5 className="text-center mb-1 text-black">
          <b>Quick Help</b>
        </h5>
        <div className="shadow-sm border-0 p-3 mb-3 bg-white rounded">
          <Accordion flush>
            {!!getFrontEndQuickReplyList &&
              getFrontEndQuickReplyList?.map((item, index) => {
                return (
                  <>
                  {
                    ((item?.question !== "undefined") && item?.question) && <Accordion.Item eventKey={index}>
                    <Accordion.Header>{item?.question}</Accordion.Header>
                    <Accordion.Body>
                      {item?.content}
                      {item?.files?.length > 0 && item.files.map((file, index) => (
                        <div key={index} className="mb-2 text-center">
                          {isImage(file?.cloudUrl) ? (
                            <img
                              onClick={() => window.open(file?.cloudUrl, "_blank")}
                              alt={`preview-${index}`}
                              src={file?.cloudUrl}
                              style={{
                                cursor: "pointer",
                                maxWidth: "100%",
                                height: "auto",
                                maxHeight: "400px",
                              }}
                            />
                          ) : isVideo(file?.cloudUrl) ? (
                            <video
                              controls
                              style={{
                                maxWidth: "100%",
                                height: "auto",
                                cursor: "pointer",
                                maxHeight: "400px",
                              }}
                              onClick={() => window.open(file?.cloudUrl, "_blank")}
                            >
                              <source src={file?.cloudUrl} />
                              Your browser does not support the video tag.
                            </video>
                          ) : isAudio(file?.cloudUrl) ? (
                            <audio
                              controls
                              preload="metadata"
                              className="chat-audio-player"
                              style={{
                                cursor: "pointer",
                                marginTop: "10px",
                              }}
                            >
                              <source
                                src={file?.cloudUrl}
                                type={getAudioMimeType(file?.cloudUrl, file?.fileType)}
                              />
                              Your browser does not support the audio element.
                            </audio>
                          ) : (
                            <span>Unsupported format</span>
                          )}
                        </div>
                      ))}
                    </Accordion.Body>
                  </Accordion.Item>
                  }
                  </>
                );
              })}
          </Accordion>
        </div>
        {/* <Row>
          <Col md={12}>
            <div className="p-3">
              <Button
                onClick={() => navigate(`/chat-users`)}
                variant="success"
                className="w-100"
              >
                <i className="bi bi-chat-dots-fill"></i> Chat With Agent
              </Button>
            </div>
          </Col>
        </Row> */}
      </div>
    </>
  );
}

export default QuickChat;
